import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class PishgamanNgnUsage {
  static uri = "a/internet/PishgamanNgnUsage";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  getAll(fileId: number, start: string | undefined, end: string | undefined) {
    return getData({
      uri: PishgamanNgnUsage.uri,
      params: `?fileId=${fileId}&start=${start}&end=${end}`,
      context: this.context,
    });
  }
}
